import React, { useState, useEffect, useCallback } from 'react';
import styles from './EditThumbnail.module.scss';
import { Icon } from '../../../../components/Icon';
import { CustomButton } from '../../../../components/Button/Button';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import CloseButton from '../../../../components/CloseButton/CloseButton';

export const EditThumbnail = ({
  handleCloseEditThumbnail,
  handleSelectThumbnail,
  staticThumbnail,
  animatedThumbnail,
  customStaticLoading,
  customAnimatedLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.editThumbnailContainer}>
      <div className={styles.thumbnailHeader}>
        <h2>Thumbnail</h2>
        <CloseButton onClose={handleCloseEditThumbnail} />
      </div>
      <div className={styles.listContainer}>
        <span className={styles.title}>{t('my_video.tools.thumbnail.static')}</span>
        <div className={cx(styles.thumbnailContainer)}>
          <div className={styles.thumbnailWrapper}>
            <img className={cx(styles.thumbnail)} src={staticThumbnail} alt={t('my_video.tools.thumbnail.static')} />
          </div>
        </div>

        <span className={styles.title}>{t('my_video.tools.thumbnail.animated')}</span>
        <div className={cx(styles.thumbnailContainer)}>
          <div className={styles.thumbnailWrapper}>
            <img className={cx(styles.thumbnail)} src={animatedThumbnail} alt={t('my_video.tools.thumbnail.animated')} />
          </div>
        </div>
        {!customAnimatedLoading && !customStaticLoading && (
          <div className={styles.selectCustom}>
            <CustomButton variant="link" onClick={handleSelectThumbnail}>
              <Icon src="upload" className={cx(styles.icon)} verticalAlign="middle" />
              <span style={{ paddingLeft: '15px' }}>{t('my_video.tools.thumbnail.select_from_video')}</span>
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};
